import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router';
import SupportThread from '../components/SupportThread';
import { STUDIO_COPY } from '../config';
import { useStudioDocumentTitle } from '../hooks/useStudioDocumentTitle';
import { getMyRttsSupportIssue, postMyRttsSupportMessage } from '../support/rttsSupportApi';
import type { LscSupportIssue } from '../../lsc/types';
import { supportIssueCategoryLabel } from '../../lsc/supportIssueCopy';

const StudioMySupportDetailPage: React.FC = () => {
  useStudioDocumentTitle('Support');
  const { issueId } = useParams<{ issueId: string }>();
  const [issue, setIssue] = useState<LscSupportIssue | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!issueId) return;
    let cancelled = false;
    void getMyRttsSupportIssue(issueId)
      .then((row) => {
        if (!cancelled) setIssue(row);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Not found');
      });
    return () => {
      cancelled = true;
    };
  }, [issueId]);

  return (
    <div className="studio-panel space-y-4" data-testid="studio-my-support-detail">
      <Link to="/studio/support" className="text-sm no-underline">
        Back to reports
      </Link>
      {error ? (
        <p className="text-red-300" role="alert">
          {error}
        </p>
      ) : null}
      {issue ? (
        <>
          <h1 className="text-2xl font-semibold">{issue.title}</h1>
          <p className="text-sm text-[var(--studio-muted)]">
            {supportIssueCategoryLabel(issue.category)} · {issue.status}
          </p>
          {issue.description ? <p className="whitespace-pre-wrap">{issue.description}</p> : null}
          <SupportThread
            messages={issue.messages || []}
            replyLabel={STUDIO_COPY.adminSupportReply}
            onSend={async (body) => {
              if (!issueId) return;
              const next = await postMyRttsSupportMessage(issueId, body);
              setIssue(next);
            }}
          />
        </>
      ) : null}
    </div>
  );
};

export default StudioMySupportDetailPage;
